import SimUserProfile from './SimUserProfile';

export default SimUserProfile;
